import Element from './Element';
import ValidatableMixin from './mixins/ValidatableMixin';
import ValueMixin from './mixins/ValueMixin';
import mixin from '../privates/utils/mixin';

/**
 * @mixin FormElement
 * @summary Provides functionality related to user input elements.
 * @description
 *  The `FormElement` [mixin](https://support.wix.com/en/article/velo-about-mixins) provides properties, functions, and event handlers that user input elements can inherit and use.
 *  
 *  > **Note:** Mixins are not elements. You cannot add mixins to a page in the Editor like other `$w` elements, and mixins are not meant to be used directly 
 *  in your code. 
 *  
 *  
 * @mixes $w.Element
 * @mixes $w.ValidatableMixin
 * @mixes $w.ValueMixin
 * @memberof $w
 */
class FormElement extends Element {}

mixin(FormElement.prototype, ValidatableMixin.prototype);
mixin(FormElement.prototype, ValueMixin.prototype);

export default FormElement;
